var _path, _path2, _mask, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGooglePlaySmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.22384 0.887448L2.21661 0.894911L2.21002 0.902948C1.89114 1.29199 1.72869 1.7902 1.75366 2.29635V21.6934C1.72293 22.2018 1.88672 22.7036 2.21198 23.0906L2.2127 23.0915L2.27223 23.1617L2.45055 23.372L2.64243 23.174L13.1795 12.3012L13.25 12.2285V12.1272V11.864V11.7627L13.1795 11.6899L2.64236 0.825944L2.46283 0.640844L2.28337 0.826019L2.22384 0.887448Z",
    fill: "#B2B6C2",
    stroke: "white",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4535 16.1714L16.5787 16.3044L16.7435 16.2255L16.841 16.1787L16.8515 16.1737L16.8615 16.1677L21.1975 13.5696L21.1979 13.5693C21.8664 13.1667 22.25 12.6061 22.25 12.0012C22.25 11.3959 21.866 10.8374 21.1969 10.4394C21.1969 10.4394 21.1968 10.4394 21.1968 10.4393L16.8514 7.84617L16.7792 7.79545L16.602 7.67092L16.4535 7.82859L12.818 11.6884L12.75 11.7606V11.8598V12.1402V12.2394L12.818 12.3116L16.4535 16.1714Z",
    fill: "#B2B6C2",
    stroke: "white",
    strokeWidth: 0.5
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-outside-1_5840_192",
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 11,
    width: 17,
    height: 13,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 1,
    y: 11,
    width: 17,
    height: 13
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 15.6069L13.205 12L2 22.6496C2.25411 22.8646 2.57937 22.9883 2.91938 22.9992C3.25939 23.0101 3.5927 22.9076 3.86151 22.7094L17 15.6069Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17 15.6069L13.205 12L2 22.6496C2.25411 22.8646 2.57937 22.9883 2.91938 22.9992C3.25939 23.0101 3.5927 22.9076 3.86151 22.7094L17 15.6069Z",
    fill: "#B2B6C2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.205 12L13.5495 11.6376L13.205 11.3102L12.8606 11.6376L13.205 12ZM2 22.6496L1.65554 22.2872L1.25144 22.6713L1.67706 23.0313L2 22.6496ZM3.86151 22.7094L3.62373 22.2696L3.59297 22.2862L3.56481 22.307L3.86151 22.7094ZM17.3445 15.2444L13.5495 11.6376L12.8606 12.3624L16.6555 15.9693L17.3445 15.2444ZM12.8606 11.6376L1.65554 22.2872L2.34446 23.012L13.5495 12.3624L12.8606 11.6376ZM1.67706 23.0313C2.01927 23.3209 2.45333 23.4845 2.90332 23.499L2.93544 22.4995C2.70542 22.4921 2.48896 22.4084 2.32294 22.2679L1.67706 23.0313ZM2.90332 23.499C3.35328 23.5134 3.79722 23.378 4.15821 23.1119L3.56481 22.307C3.38818 22.4372 3.16549 22.5069 2.93544 22.4995L2.90332 23.499ZM4.09929 23.1493L17.2378 16.0467L16.7622 15.167L3.62373 22.2696L4.09929 23.1493Z",
    fill: "white",
    mask: "url(#path-3-outside-1_5840_192)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1722 8.5737L17.422 8.33628L17.1188 8.17253L3.99616 1.08578C3.68571 0.857724 3.30333 0.739947 2.91404 0.750673C2.51817 0.761581 2.13721 0.904781 1.83847 1.15767L1.6258 1.3377L1.82776 1.52967L13.0328 12.1812L13.205 12.3449L13.3773 12.1812L17.1722 8.5737Z",
    fill: "#B2B6C2",
    stroke: "white",
    strokeWidth: 0.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M16.8921 16L3.86151 22.6113C3.60247 22.7855 3.28677 22.8798 2.96223 22.8798C2.63769 22.8798 2.32199 22.7855 2.06295 22.6113L2 22.6674L2.06295 22.7315C2.32199 22.9058 2.63769 23 2.96223 23C3.28677 23 3.60247 22.9058 3.86151 22.7315L17 16.0721L16.8921 16Z",
    fill: "#B2B6C2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M21.1254 13.2322L17 15.9147L17.0743 16L21.1254 13.3649C21.3645 13.2488 21.572 13.0607 21.7259 12.8205C21.8798 12.5803 21.9745 12.2968 22 12C21.9484 12.2697 21.8424 12.5218 21.6905 12.7358C21.5386 12.9498 21.345 13.1199 21.1254 13.2322Z",
    fill: "#B2B6C2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M4.20009 1.41085L21.0819 10.8881C21.3124 10.9894 21.5156 11.1429 21.6751 11.336C21.8345 11.5292 21.9458 11.7566 22 12C21.9732 11.7321 21.8738 11.4764 21.7123 11.2596C21.5507 11.0429 21.3329 10.8731 21.0819 10.7683L4.20009 1.2911C2.9961 0.606824 2 1.17135 2 2.5399V2.6682C2.02599 1.29965 2.9961 0.735126 4.20009 1.41085Z",
    fill: "#B2B6C2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlaySmall);
export default __webpack_public_path__ + "static/media/googlePlaySmall.dd9ba056b5848c9ea3ec6bcdd4f14819.svg";
export { ForwardRef as ReactComponent };